/**
 * CHỮ DO MÁY CHỦ SOẠN (lời báo lỗi, nhãn kỳ báo cáo, đuôi bài phân tích) giữ nguyên văn của hệ thống cũ để
 * bộ đối chiếu `apps/api/test/parity` còn so được — trong đó có emoji và mũi tên mà font Mulish không có,
 * hiện ra sẽ lệch kiểu với cả trang. Đổi sang dạng hiển thị được NGAY TRƯỚC KHI vẽ; không sửa ở máy chủ.
 *
 * Dựng biểu thức từ MÃ SỐ, không gõ thẳng ký tự: chính file này cũng phải qua `source-hygiene.test.ts`.
 */
const chars = (...codes: number[]) => String.fromCodePoint(...codes);

const RIGHT_ARROW = chars(0x2192);
const LEFT_ARROW = chars(0x2190);
/** «14/09 → 20/09/2026»: mũi tên giữa hai con số là một KHOẢNG → gạch nối dài. */
const RANGE_ARROW = new RegExp(`(\\d)\\s*${RIGHT_ARROW}\\s*(\\d)`, 'gu');
const REPLACEMENTS: ReadonlyArray<readonly [pattern: RegExp, replacement: string]> = [
  [RANGE_ARROW, `$1 ${chars(0x2013)} $2`],
  // «Cài đặt → Khoá API»: mũi tên chỉ đường đi trong menu → dấu ngoặc nhọn đơn.
  [new RegExp(RIGHT_ARROW, 'gu'), chars(0x203a)],
  [new RegExp(LEFT_ARROW, 'gu'), chars(0x2039)],
  [new RegExp(chars(0x2265), 'gu'), '>='],
  [new RegExp(chars(0x2264), 'gu'), '<='],
  [new RegExp(chars(0x2248), 'gu'), '~'],
];
/**
 * Hình vẽ thay icon (cấm, cảnh báo, bánh răng, dấu tích…) kèm dấu chọn kiểu emoji và khoảng trắng theo
 * sau: bỏ hẳn — thông báo của Ant Design đã có icon đúng bộ.
 */
const PICTOGRAPHS = new RegExp(
  `[\\u{2300}-\\u{23ff}\\u{25a0}-\\u{25ff}\\u{2600}-\\u{27bf}\\u{2b00}-\\u{2bff}\\u{1f000}-\\u{1faff}]` +
    `\\u{fe0f}?\\s*`,
  'gu',
);

export function toDisplayText(text: string): string {
  let result = text;
  for (const [pattern, replacement] of REPLACEMENTS) result = result.replace(pattern, replacement);
  return result.replace(PICTOGRAPHS, '');
}
